import { apiPost } from "../baseApi";

export const reInvite = async (data) => {
  try {
    const response = await apiPost(`_userReInvite`,data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
